import { withAITracking } from '@microsoft/applicationinsights-react-js';

import { SectionTitleButtons } from 'library/components/controls/layout/SectionTitleButtons';
import { ServiceAreaTabs } from 'library/components/controls/layout/tabs/ServiceAreaTabs';
import { PageContentTab } from 'library/components/controls/pageTemplates/PageContent';
import { useAdobeTracking } from 'library/hooks/useAdobeTracking';
import { reactPlugin } from 'main/azureInsights/config';
import { ErrorComponentFallback } from 'main/errors/ErrorComponentFallback';
import { productIndividualServicesAreaTabsConfiguration } from 'modules/ProductIndividualview/servicesAreaTabsConfiguration';
import { MaintenancePlannerButton } from 'modules/Shared/Components/Buttons/MaintenancePlannerButton';

const ServiceAreaPage = (): React.JSX.Element => {
	const { trackApplicationInteraction } = useAdobeTracking();

	return (
		<>
			<SectionTitleButtons>
				<MaintenancePlannerButton source="ProductIndividualView" />
			</SectionTitleButtons>
			<ServiceAreaTabs
				tabs={productIndividualServicesAreaTabsConfiguration}
				onTabClick={(tabPath) =>
					void trackApplicationInteraction({
						action: 'click',
						stepName:
							'PRODUCTINDIVIDUALVIEW Service Area Tab Navigation',
						selectedOptions: [{ attribute: 'tab', value: tabPath }],
					})
				}
			/>
			<PageContentTab ErrorFallbackComponent={ErrorComponentFallback} />
		</>
	);
};

export default withAITracking(
	reactPlugin,
	ServiceAreaPage,
	'ProductIndividualServiceAreaPage',
	'application-insight-container'
);
